/*
 * Copyright (c) 2026 Talent Catalog.
 *
 * This program is free software: you can redistribute it and/or modify it under
 * the terms of the GNU General Public License as published by the Free
 * Software Foundation, either version 3 of the License, or any later version.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or
 * FITNESS FOR A PARTICULAR PURPOSE. See the GNU General Public License
 * for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program. If not, see https://www.gnu.org/licenses/.
 */

import {Pipe, PipeTransform} from '@angular/core';
import {Candidate} from "../model/candidate";

@Pipe({
  name: 'candidate'
})
export class CandidatePipe implements PipeTransform {

  transform(candidate: Candidate, args?: any): any {
    const u = candidate.user;
    switch (args) {
      case 'name':
        return u ? u.firstName + ' ' + u.lastName : 'Candidate ' + candidate.candidateNumber;

      default:
        return u ? u.firstName + ' ' + u.lastName : 'Candidate ' + candidate.candidateNumber;
    }
  }

}
